import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  deleteBrandModelWarranty,
  getBrandModelWarranties,
} from "services/warranty-services";

export const getAllWarrantiesThunk = createAsyncThunk(
  "getAllWarrantiesThunk",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getBrandModelWarranties();
      return data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const getDefaultWarrantiesThunk = createAsyncThunk(
  "getDefaultWarrantiesThunk",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getBrandModelWarranties({ isDefaultBrand: true });
      return data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteBrandModelWarrantyThunk = createAsyncThunk(
  "deleteBrandModelWarrantyThunk",
  async (id: number, { rejectWithValue }) => {
    try {
      const result = await deleteBrandModelWarranty(id);
      return {
        id,
        response: result.data,
      };
    } catch (err: any) {
      return rejectWithValue(err.response?.data);
    }
  }
);
